import { ReactElement } from 'react';

import { ContactFooter } from './ContactFooter';
import { OnboardingProgressBar } from './OnboardingProgressBar/OnboardingProgressBar';
import { Sidebar } from './Sidebar';

export const OnboardingLayout = ({ children }: { children: ReactElement }) => {
    return (
        <div className="-mt-header-offset grid min-h-screen grid-cols-8 bg-structure-100">
            <div className="col-span-full min-m:col-span-2">
                <Sidebar />
            </div>
            <div className="col-span-full grid grid-cols-4 py-2xl min-m:col-span-6">
                <div className="col-span-full mx-2xl min-m:col-span-2 min-m:col-start-2">
                    <OnboardingProgressBar />
                    {children}
                </div>
            </div>
            <div className="col-span-full block min-m:hidden">
                <ContactFooter />
            </div>
        </div>
    );
};
